<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_5"><img alt="Images" height="216" src="images/f0005-01.jpg" width="500"/></a></p><a id="page_5">
<p class="center">To</p>
<p class="center">Paul and Maureen Beebe</p>
<p class="center">Grandpa and Grandma Beebe</p>
<p class="center">Eba Jones, Fire Chief</p>
<p class="center">Wyle Maddox, Leader of Roundup Men</p>
<p class="center">L. Quillen, Roundup Man</p>
<p class="center">Wilbur Wimbrow, Roundup Man</p>
<p class="center">Howard Rodgers, Roundup Man</p>
<p class="center">Harvey Beebe, Roundup Man</p>
<p class="center">Harold Beebe, father of Paul and Maureen</p>
<p class="center">Ralph Beebe, uncle of Paul and Maureen</p>
<p class="center">Delbert Daisey, Bronc Buster</p>
<p class="centerb">Victoria and William Pruitt</p>
<p class="centerb">all of whom really live on Chincoteague Island and who appear as characters in this book</p>
<p class="center"><span class="txit">and a special dedication to Three Chincoteague Ponies</span></p>
<p class="center"><span class="txit">Phantom<br/>Pied Piper<br/>Misty</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?9fff6a5c